import axios from 'axios';

// 生产环境走同源相对路径（nginx 代理），开发环境直连 hk-api:18080
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:18080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('agent_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res.data,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('agent_token');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const agentAPI = {
  login: (email, password) => api.post('/agent/login', { email, password }),
  getInfo: () => api.get('/agent/info'),
  getUsers: (params) => api.get('/agent/users', { params }),
  getOrders: (params) => api.get('/agent/orders', { params }),
  getConsumptionStats: (params) => api.get('/agent/consumption/stats', { params }),
  getBilling: (params) => api.get('/agent/billing', { params }),
  getModelList: () => api.get('/agent/models'),
  changePassword: (oldPassword, newPassword) =>
    api.post('/user/change-password', { old_password: oldPassword, new_password: newPassword }),
};

// 流水明细 CSV 导出地址（带 token 走查询参数，便于直接下载）
export const billingExportUrl = (params) => {
  const token = localStorage.getItem('agent_token') || '';
  const qs = new URLSearchParams({ ...params, token }).toString();
  return `${API_BASE_URL}/agent/billing/export?${qs}`;
};

export default api;
